import React from 'react'
import R from 'ramda'
import {defineMessages, injectIntl, FormattedMessage} from 'react-intl'

import PriceRange from './PriceRange'
import Price from './Price'

const m = defineMessages({
  '/month': {id:'/month', defaultMessage: '/month'},
})

class PriceField extends React.Component {
  constructor(props){
    super(props)
    const prices = props.prices
    this.state = prices
  }
  onUpdate(values){
    this.setState(values)
  }
  render(){

    const {rental, validValues, currency, onChange} = this.props
    const {min, max} = this.state
    
    const priceUnit = rental ? this.props.intl.formatMessage(m["/month"]) : ''
    
    return <div className="range-field-container price-range">
        <div className="range-field-values-container">
          <Price amount={min} currency={currency} perUnit={priceUnit}/> 
          &nbsp;
          <FormattedMessage id="to" defaultMessage="to"/>
          &nbsp; 
          {max == -1 ? <FormattedMessage id="Unlimited" defaultMessage="Unlimited"/> : <Price amount={max} currency={currency} perUnit={priceUnit}/>}
        </div>
        <PriceRange validValues={validValues} min={min} max={max} onChange={onChange} onUpdate={this.onUpdate.bind(this)}/>
      </div>
  }
}

PriceField.propTypes = {
  prices: React.PropTypes.shape({
    min: React.PropTypes.number,
    max: React.PropTypes.number,
  }),
  currency: React.PropTypes.string.isRequired,
  onChange: React.PropTypes.func.isRequired,
  validValues: React.PropTypes.array.isRequired
}

export default injectIntl(PriceField)



/** WEBPACK FOOTER **
 ** ./app/components/PriceField.jsx
 **/